import { Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseEntityComponent, BaseEntityConfig, BnLoadingService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { SolicitacaoHonra, SolicitacaoHonraArquivoSCR } from 'src/app/model/solicitacao-honra.model';
import { TIPOS_VALIDACAO_ARQ_SCR} from 'src/app/model/validacao-scr.model';
import Utils from 'src/app/shared/fgi-utils';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ArquivoPopupComponent } from './arquivo-popup.component';
import { SolicitacaoHonraService } from './solicitacao-honra.service';

@Component({
    selector: 'app-solicitacao-honra-detalhe',
    templateUrl: './solicitacao-honra-detalhe.component.html',
    styleUrls: ['./solicitacao-honra-detalhe.component.scss'],
    standalone: false
})
export class SolicitacaoHonraDetalheComponent extends BaseEntityComponent<SolicitacaoHonra> implements OnInit {

    tiposValidacaoScr = TIPOS_VALIDACAO_ARQ_SCR;
    private agentesFinanceiros: AgenteFinanceiro[] = [];
    private idSolicitacaoHonra: number;
    private solicitacaoHonra: SolicitacaoHonra;
    private permissaoLinkN03: false;
    private podeReprovar = false;
    private ocorrencias: OcorrenciaValidacaoVO[] = [];

    @ViewChild('reprovacao') reprovacao: TemplateRef<any>;
    private motivoReprovacao: string;
    @ViewChild('reprovacaoBotoes') reprovacaoBotoes: TemplateRef<any>;
    podeVisualizarValidacoes: boolean;

    constructor(protected injector: Injector,
                protected service: SolicitacaoHonraService,
                private permissaoService: PermissaoService,
                private modalService: BnModalMessageService,
                private loadingService: BnLoadingService,
                private activatedRoute: ActivatedRoute,
                private _modalService: NgbModal,
                ) {

        super(service, new BaseEntityConfig('/solicitacoes-honra'));
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
        this.config.rotaLista = '/solicitacoes-honra/pesquisa';
    }

    ngOnInit() {
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.permissaoLinkN03 = resp && (resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO]);
            this.podeReprovar = resp && resp[ROLE_GESTOR_ENVIO];
            this.podeVisualizarValidacoes = resp && resp[ROLE_GESTOR_CONSULTA];
        });
        this.route.params.subscribe(params => {
            this.idSolicitacaoHonra = params['id'];
            this.service.getSolicitacaoHonra(this.idSolicitacaoHonra).subscribe(resp => {
                this.solicitacaoHonra = resp;
            });
        });
    }

    reprovar() {
        this.motivoReprovacao = "";
        this.modalService
                .abrir('Reprovação da Solicitação de Honra', null, 'lg', this.reprovacao, this.reprovacaoBotoes)
            .result
                .then((solicitacaoHonraReprovada: SolicitacaoHonra) => {
                    //console.log(`retornou: ${JSON.stringify(solicitacaoHonraReprovada)}`);
                    this.solicitacaoHonra = solicitacaoHonraReprovada;
                    this.messageService.addMessage({
                        title: 'Sucesso',
                        type: 'CRUD_OPERATION',
                        level: messageLevel.SUCCESS,
                        message: 'Solicitação de honra reprovada com sucesso.'
                    });
                    this.ocorrencias = [];
                }, (reason) => {
                    console.log(reason);
                });
    }

    visualizarOperacao(solicitacaoHonraArquivo:SolicitacaoHonraArquivoSCR){
        const modalRef = this._modalService.open(ArquivoPopupComponent, {
            windowClass: 'modal-dialog-xl',
            backdrop: 'static'
          });

        modalRef.componentInstance.solicitacaoHonraArquivo = solicitacaoHonraArquivo;
    }

    confirmaReprovacao() {
        this.loadingService.bloqueiaTela();
        this.service.reprovar(this.idSolicitacaoHonra, this.motivoReprovacao)
            .subscribe(solicitacaoHonraReprovada => {
                this.modalService.close(solicitacaoHonraReprovada);
                this.loadingService.liberaTela();
            }, error => {
                console.log(error);
                this.ocorrencias = this.service.ocorrencias;
                this.loadingService.liberaTela();
            });
    }

    cancelaReprovacao() {
        this.modalService.dismiss("abortou reprovação");
    }

    private nomeAgente(cnpj: string) {
        return Utils.nomeAgentePorCNPJ(cnpj, this.agentesFinanceiros);
    }

    private mesAno(valor?: string): string {
        return Utils.mesAno(valor);
    }

    private labelTipoValidacaoScr(codigo: string): string {
        return this.tiposValidacaoScr.find(tipo => tipo.codigo === codigo).label;
    }

}
